













































































import Vue from 'vue'
import moment from 'moment'
import _ from 'lodash'

// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import EmployeeBooleanCellRenderer from '@/components/cell-renderer/EmployeeBooleanCellRenderer.vue'
import EmployeeSelectorDialog from '@/components/planning/shift/ShiftEditorEmployeeSelectorDialog.vue'
import { EmployeePlaceholder } from '@/model/planning/EmployeePlaceholder'
import {
  AutomaticPlanningPayload, CompanyFilterValue, CreateShiftPayload,
  FetchEmployeePlaceholderListPayload,
  PlanningAssistantPeriodicityPayload
} from '@/types/payload'
import {
  AUTOMATICALLY_PLAN_EMPLOYEES,
  FETCH_EMPLOYEE_PLACEHOLDER_LIST,
  PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE,
  PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID,
  PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT,
  PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  CREATE_SHIFT_NEW, PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST
} from '@/store/action-types'
import { AutomaticallyPlannedEmployee } from '@/model/planning/AutomaticallyPlannedEmployee'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import {
  COMPANY_GET_BASIC_COMPANY_STRUCTURE, GET_CURRENT_USER_ID,
  GET_SELECTED_UI_LANGUAGE,
  PLANNING_ASSISTANT_GET_COMPANY_FILTER,
  PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_DELETION,
  PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_EXCHANGE, PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING,
  PLANNING_ASSISTANT_GET_END_DATE,
  PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT,
  PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY,
  PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST, PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY,
  PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM,
  PLANNING_ASSISTANT_GET_START_DATE, PLANNING_ASSISTANT_GET_TASK_LIST
} from '@/store/getter-types'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import EmployeeExchangeCellRenderer from '@/components/cell-renderer/EmployeeExchangeCellRenderer.vue'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import EmployeeDeleteCellRenderer from '@/components/cell-renderer/EmployeeDeleteCellRenderer.vue'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { CompanyStructure, PeriodicityPlannedEmployee } from '@/types'
import { Employee } from '@/model/companyStructure/Employee'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { ShiftAvailability } from '@/types/enums'
import * as planningService from '@/services/planning-service'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import { Task } from '@/model/planning/Task'
import { Address } from '@/model/planning/Address'
import { CreateShiftNewResponse } from '@/types/service-response'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  gridRowList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder>
  showEmployeeSelector: boolean,
  autoPlannedEmployeeList: Array<EmployeePlaceholder | AutomaticallyPlannedEmployee>,
  displayedAutoPlannedEmployees: Array<EmployeePlaceholder | AutomaticallyPlannedEmployee>
  selectedEmployees: Array<PlannedEmployee>
  loadSelectedEmployee: boolean
  overlayNoRowsTemplate: string
  isPlaned: boolean
  panel: number[]
  periodicitySelectedRow: string | undefined
  selectedItem: any
  changeEmployee: PlannedEmployee | undefined
  loading: boolean
  originalPlaceholderList: EmployeePlaceholder[]
}

export default Vue.extend({
  name: 'ShiftEditorEmployeeAutomaticPlanning',

  components: {
    AgGridVue,
    EmployeeSelectorDialog,
    ProgressCircular
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          {
            headerName: '',
            field: 'fullName',
            cellRenderer: 'employeeExchangeCellRenderer',
            width: 100
          },
          {
            headerName: '',
            field: 'fullName',
            cellRenderer: 'employeeDeleteCellRenderer',
            width: 100
          },
          { headerName: this.$t('planningPage.name').toString(), width: 400, field: 'fullName' },
          { headerName: this.$t('planningPage.competence').toString(), field: 'competence' },
          { headerName: this.$t('planningPage.education').toString(), field: 'education' },
          {
            headerName: this.$t('planningPage.jumper').toString(),
            field: 'isFloater',
            cellRenderer: 'booleanRenderer',
            width: 120
          },
          { headerName: this.$t('planningPage.planningGroup').toString(), field: 'planningGroupName', width: 250 },
        ],
      },

      gridFrameworkComponents: {
        booleanRenderer: EmployeeBooleanCellRenderer,
        employeeExchangeCellRenderer: EmployeeExchangeCellRenderer,
        employeeDeleteCellRenderer: EmployeeDeleteCellRenderer
      },

      gridRowList: [],
      showEmployeeSelector: false,
      autoPlannedEmployeeList: [],
      displayedAutoPlannedEmployees: [],
      selectedEmployees: [],
      loadSelectedEmployee: true,
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      isPlaned: false,
      panel: [0],
      periodicitySelectedRow: undefined,
      selectedItem: undefined,
      changeEmployee: undefined,
      loading: false,
      originalPlaceholderList: []
    }
  },

  props: {
    editShift: Object as () => EditShiftPlan | undefined,
    selectedAddress: Object as () => Address | undefined,
    selectedProject: Object as () => PlanningLookupProject | null,
  },

  computed: {
    disabledAutoPlanning (): boolean {
      return this.editShift === undefined
    },

    dateStart (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
    },

    selectedTemplateItem (): ShiftTemplate {
      return this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    companyFilter (): CompanyFilterValue {
      return this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
    },

    selectedRowItem (): AutomaticallyPlannedEmployee | EmployeePlaceholder | undefined {
      return this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_EXCHANGE]
    },

    selectedRowForDeletion (): AutomaticallyPlannedEmployee | undefined {
      return this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_FOR_DELETION]
    },

    plannedEmployeeList (): PlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    showAutomaticPlanningButton (): boolean {
      if(this.gridRowList.filter((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => !item.isPlaceholder).length > 0 && !this.periodicity.isUnique) {
        return false
      } else {
        return true
      }
    },

    companyStructure(): CompanyStructure {
      return this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]
    },

    currentUserId (): number | undefined {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },
  },

  watch: {
    selectedTemplateItem (newVal: ShiftTemplate): void {
      if (newVal) {
        // noinspection JSIgnoredPromiseFromCall
        this.fetchEmployeePlaceholderList()
      }
    },

    selectedRowItem (newVal: AutomaticallyPlannedEmployee | EmployeePlaceholder): void {
      if (newVal) {
        this.showEmployeeSelector = true
      }
    },

    selectedRowForDeletion (newVal: AutomaticallyPlannedEmployee): void {
      if (newVal) {
        this.deleteEmployee()
      }
    },

    plannedEmployeeList (newVal): void {
      if (newVal) {
        if (this.loadSelectedEmployee || newVal.filter((item: PlannedEmployee) => !!item.id).length !== this.selectedEmployees.length) {
          /*newVal.forEach((item: PlannedEmployee) => {
            if (item.id && item.planingGroupName) {
              this.selectedEmployees.push(item)
            }
          })*/
          this.selectedEmployees = newVal.filter((item: PlannedEmployee) => !!item.id)
          if(!this.loadSelectedEmployee) {
            this.fetchEmployeePlaceholderList()
          }
        }
      }
    }
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    floaterIconColor (employee: PlannedEmployee): string {
      const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
      const result: boolean = employees.some((item: Employee) => item.id === employee.id)
      return result ? 'red' : 'green'
    },

    floaterIcon (employee: PlannedEmployee): string {
      const employees: Array<Employee> = this.$store.getters[PLANNING_ASSISTANT_GET_FILTERED_EMPLOYEES_BY_DEPARTMENT]
      const result: boolean = employees.some((item: Employee) => item.id === employee.id)
      return result ? 'clear' : 'check'
    },

    onPeriodicityRemoveEmployeeButtonClick (idx: number, employee: PlannedEmployee) {
      const placeholder: EmployeePlaceholder | undefined = this.originalPlaceholderList.find((item: EmployeePlaceholder) => employee.number === item.number)
      const avatar: PlannedEmployee = new PlannedEmployee(
        undefined,
        '',
        undefined,
        false,
        employee.competenceName,
        employee.educationName,
        employee.start,
        employee.end,
       placeholder ? placeholder.planningGroupName : undefined,
          placeholder ? placeholder.taskName : undefined,
        undefined,
          placeholder ? placeholder.taskId : undefined,
        employee.number,
        employee.detailID
      )

      let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
      localPlannedEmployeeList[idx].employeeList.splice(
        _.findIndex(localPlannedEmployeeList[idx].employeeList, { detailID: employee.detailID }), 1, avatar)
      this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
    },

    onChangeEmployeeButtonClick (item: PeriodicityPlannedEmployee, employee: PlannedEmployee): void {
      this.showEmployeeSelector = true
      this.changeEmployee = employee
      this.selectedItem = item
      this.periodicitySelectedRow = _.findIndex(this.periodicityPlannedEmployeeList, { date: item.date }).toString()
    },

    onAutomaticPlanningButtonClick (): void {
      // noinspection JSIgnoredPromiseFromCall
      this.planEmployees()
    },

    updatePlannedEmployees (itemList: EmployeePlaceholder[] | AutomaticallyPlannedEmployee[]): void {
      const employeeList: PlannedEmployee[] = PlannedEmployee.createListFromEmployeeItemList(itemList, this.dateStart, this.dateEnd)

      this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, employeeList)
    },

    async fetchEmployeePlaceholderList (): Promise<void> {
      const templateItem: ShiftTemplate = this.selectedTemplateItem

      const payload: FetchEmployeePlaceholderListPayload = {
        shiftTemplateId: templateItem!.id
      }

      this.originalPlaceholderList = await this.$store.dispatch(FETCH_EMPLOYEE_PLACEHOLDER_LIST, payload)
      const placeholderList: EmployeePlaceholder[] = _.cloneDeep(this.originalPlaceholderList)

      this.autoPlannedEmployeeList = _.cloneDeep(placeholderList)
      this.displayedAutoPlannedEmployees = placeholderList

      const localPlannedEmployeeList: PlannedEmployee[] = _.cloneDeep(this.selectedEmployees)
      localPlannedEmployeeList.forEach((i: PlannedEmployee) => {
        const originalPlaceholder: EmployeePlaceholder | undefined =
          this.autoPlannedEmployeeList.find((placeholder: EmployeePlaceholder) => placeholder.number === i.number)

        if (originalPlaceholder) {
          const newAutoPlannedEmployee: AutomaticallyPlannedEmployee =
            AutomaticallyPlannedEmployee.createFromEmployeeAvailableForPlanningAndPlaceholder(i, originalPlaceholder, i)

          this.displayedAutoPlannedEmployees.splice(
            _.findIndex(this.displayedAutoPlannedEmployees, { number: newAutoPlannedEmployee.number }),
            1, newAutoPlannedEmployee)

        }
      })

      if (this.editShift && this.loadSelectedEmployee) {
        const placeholderList: EmployeePlaceholder[] = EmployeePlaceholder.createEmployeePlaceholderListFromEditShift(this.editShift, this.autoPlannedEmployeeList, this.companyStructure.planningGroupList)
        placeholderList.forEach((item: EmployeePlaceholder) => {
          this.displayedAutoPlannedEmployees.splice(
            _.findIndex(this.displayedAutoPlannedEmployees, { number: item.number }),
            1, item)
        })
      }

      this.updatePlannedEmployees(placeholderList)
      this.gridRowList = this.displayedAutoPlannedEmployees.map((item: EmployeePlaceholder) => {
        return Object.assign({}, item)
      })
      this.loadSelectedEmployee = false
    },

    async planEmployees (): Promise<void> {
      try {
        this.loading = true

        const payload: AutomaticPlanningPayload = {
          ID: this.selectedTemplateItem.id,
          SchichtName: this.selectedTemplateItem.description,
          ProfitCenter: this.companyFilter.profitCenter!.id,
          Abteilung: this.companyFilter.department!.id,
          Sachbearbeiter: this.currentUserId ? this.currentUserId : null,
          ReferenzTermin: this.dateStart ? moment(this.dateStart).format('YYYY/MM/DD HH:mm') : null,
          Montag: this.periodicity.weekDayList.includes(1),
          Dienstag: this.periodicity.weekDayList.includes(2),
          Mittwoch: this.periodicity.weekDayList.includes(3),
          Donnerstag: this.periodicity.weekDayList.includes(4),
          Freitag: this.periodicity.weekDayList.includes(5),
          Samstag: this.periodicity.weekDayList.includes(6),
          Sonntag: this.periodicity.weekDayList.includes(7),
          Whlg: this.periodicity.repeatEveryNthWeek,
          Einmalig: this.periodicity.isUnique,
          Sprache: this.$store.state.selectedUiLanguage!.syzId,
          EndAfternTimes: this.periodicity.expireAfterRepetitions > 0 ? this.periodicity.expireAfterRepetitions : null,
          EndAfterDate: this.periodicity.expireAfterDate ? moment(this.periodicity.expireAfterDate).format('YYYY/MM/DD HH:mm') : null,
          AdressID: this.selectedAddress ? this.selectedAddress.id : null,
          ReferenzProjektID: this.selectedProject ? this.selectedProject.id : null,

        }

        let autoPlannedEmployeeList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder> = await this.$store.dispatch(AUTOMATICALLY_PLAN_EMPLOYEES, payload)

        if (this.periodicity.isUnique && autoPlannedEmployeeList) {
          this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT, true)
        } else {
          this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT, false)
        }

        const foundProjectId: AutomaticallyPlannedEmployee | EmployeePlaceholder | undefined = autoPlannedEmployeeList
          .find((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => item.projectId !== undefined)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID, foundProjectId ? foundProjectId.projectId : undefined)

        if (!this.periodicity.isUnique) {
          // Auto create periodicity

          this.$store.dispatch(PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE, true)

          const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
          const employeeList: PlannedEmployee[] = PlannedEmployee.createListFromAutoPlannedEmployees(autoPlannedEmployeeList, availableEmployeeList)

          let data: PeriodicityPlannedEmployee[] = []
          employeeList.forEach((item: PlannedEmployee) => {
            let foundItem: PeriodicityPlannedEmployee | undefined

            if (data.length > 0) {
              foundItem = data.find((i: PeriodicityPlannedEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
            }

            if (foundItem) {
              foundItem.employeeList.push(item)
            } else {
              data.push({ date: moment(item.start).format('DD.MM.YYYY'), employeeList: [item] })
            }
          })

          data = _.sortBy(data, [function (o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD') }])

          this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)

        } else {
          // Auto create normal

          const placeholderList: EmployeePlaceholder[] = EmployeePlaceholder.createEmployeePlaceholderList(autoPlannedEmployeeList, this.autoPlannedEmployeeList)

          autoPlannedEmployeeList = autoPlannedEmployeeList.map((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => {
            if (!item.employeeId) {
              const placeholder: EmployeePlaceholder | undefined = placeholderList.find((i: EmployeePlaceholder) => i.number === item.number)
              return placeholder ? placeholder : item
            } else {
              return item
            }
          })

          const employeeList: PlannedEmployee[] = PlannedEmployee.createListFromAutoPlannedEmployees(autoPlannedEmployeeList)
          this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, employeeList)

          this.displayedAutoPlannedEmployees = autoPlannedEmployeeList

          this.gridRowList = this.displayedAutoPlannedEmployees.map((item: AutomaticallyPlannedEmployee) => {
            return Object.assign({}, item)
          })
        }

        this.isPlaned = true

      } finally {
        this.loading = false
      }
    },

    onCloseEmployeeSelector (): void {
      this.showEmployeeSelector = false
    },

    onEmployeeExchange (employeeList: EmployeeAvailableForPlanning[]): void {
      if (!this.changeEmployee) {
        this.showEmployeeSelector = false
        let plannedEmployee: PlannedEmployee | undefined

        const localPlannedEmployeeList: PlannedEmployee[] = _.cloneDeep(this.plannedEmployeeList)

        const selectedRowItem: AutomaticallyPlannedEmployee | EmployeePlaceholder | undefined = this.selectedRowItem

        const originalPlaceholder: EmployeePlaceholder | undefined =
          _.find(this.autoPlannedEmployeeList, {
            number: selectedRowItem!.number,
          })

        if (selectedRowItem!.number) {
          plannedEmployee = _.find(localPlannedEmployeeList, { number: selectedRowItem!.number })
        }

        if (originalPlaceholder) {
          const newAutoPlannedEmployee: AutomaticallyPlannedEmployee =
            AutomaticallyPlannedEmployee.createFromEmployeeAvailableForPlanningAndPlaceholder(employeeList[0], originalPlaceholder, plannedEmployee)

          this.displayedAutoPlannedEmployees.splice(
            _.findIndex(this.displayedAutoPlannedEmployees, { number: newAutoPlannedEmployee.number }),
            1, newAutoPlannedEmployee)

          let employeeIndex = _.findIndex(this.autoPlannedEmployeeList, {
            number: newAutoPlannedEmployee.number
          })

          if (employeeIndex !== -1) {
            const newPlannedEmployee: PlannedEmployee = PlannedEmployee.createListFromEmployeeItemList(
              [newAutoPlannedEmployee],
              newAutoPlannedEmployee.startDate,
              newAutoPlannedEmployee.endDate)[0]

            localPlannedEmployeeList.splice(employeeIndex, 1, newPlannedEmployee)

            this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
          }
        }

        this.gridRowList = this.displayedAutoPlannedEmployees.map((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => {
          return Object.assign({}, item)
        })

        this.$store.dispatch(PLANNING_ASSISTANT_SET_EMPLOYEE_FOR_EXCHANGE, undefined)
      } else {
        const selectedEmployeeList: PlannedEmployee[] = employeeList
          .map((item: EmployeeAvailableForPlanning): PlannedEmployee => {
            return new PlannedEmployee(
              item.id,
              item.name,
              item.capacity,
              item.isFloater,
              this.changeEmployee!.competenceName,
              this.changeEmployee!.educationName,
              this.changeEmployee!.start,
              this.changeEmployee!.end,
              item.planingGroupName,
              this.changeEmployee!.taskName,
              this.changeEmployee!.note,
              this.changeEmployee!.taskId,
              this.changeEmployee!.number,
              this.changeEmployee!.detailID
            )
          })

        let localPlannedEmployeeList: PeriodicityPlannedEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        const index: number = this.periodicityPlannedEmployeeList.indexOf(this.selectedItem)
        const employeeIndex: number = this.periodicityPlannedEmployeeList[index].employeeList.indexOf(this.changeEmployee)
        localPlannedEmployeeList[index].employeeList.splice(employeeIndex, 1, selectedEmployeeList[0])

        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
        this.showEmployeeSelector = false
        this.periodicitySelectedRow = undefined
      }
    },

    deleteEmployee () {
      let plannedEmployee: PlannedEmployee | undefined

      const localPlannedEmployeeList: PlannedEmployee[] = _.cloneDeep(this.plannedEmployeeList)

      const selectedRowItem: AutomaticallyPlannedEmployee | undefined = this.selectedRowForDeletion

      const originalPlaceholder: EmployeePlaceholder | undefined =
        _.find(this.autoPlannedEmployeeList, {
          number: selectedRowItem!.number,
        })

      if (selectedRowItem!.number) {
        plannedEmployee = _.find(localPlannedEmployeeList, { number: selectedRowItem!.number })
      }

      if (originalPlaceholder) {
        this.displayedAutoPlannedEmployees.splice(
          _.findIndex(this.displayedAutoPlannedEmployees, { number: selectedRowItem!.number }),
          1, originalPlaceholder)

        let employeeIndex = _.findIndex(this.autoPlannedEmployeeList, {
          number: originalPlaceholder.number
        })

        if (employeeIndex !== -1) {
          const newPlannedEmployee: PlannedEmployee = PlannedEmployee.createFromPlaceholderAndPlannedEmployee(
            originalPlaceholder,
            plannedEmployee!
          )

          localPlannedEmployeeList.splice(employeeIndex, 1, newPlannedEmployee)

          this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
        }
      }

      this.gridRowList = this.displayedAutoPlannedEmployees.map((item: AutomaticallyPlannedEmployee | EmployeePlaceholder) => {
        return Object.assign({}, item)
      })

      this.$store.dispatch(PLANNING_ASSISTANT_DELETE_EMPLOYEE_FOR_EXCHANGE, undefined)
    },

    async onScheduleButtonClick (): Promise<void> {
      try {
        this.loading = true
        const filterValue: CompanyFilterValue = this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
        const dateStart: Date = this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
        const dateEnd: Date = this.$store.getters[PLANNING_ASSISTANT_GET_END_DATE]
        const periodicity: PlanningAssistantPeriodicityPayload = this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
        const availability: ShiftAvailability = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_AVAILABILITY]
        const shiftTemplate: ShiftTemplate | undefined = this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]

        const newShiftPayload: CreateShiftPayload = planningService.composeCreateNewShiftPayload(
          filterValue.profitCenter!.id,
          filterValue!.department!.id,
          this.$store.state.currentUser!.id,
          this.$store.state.selectedUiLanguage!.syzId,
          dateStart,
          dateEnd,
          periodicity,
          availability,
          shiftTemplate,
         this.selectedAddress ? this.selectedAddress.id : null,
         this.selectedProject ? this.selectedProject.id : null,
         [],
          this.plannedEmployeeList)

        const newShiftData: CreateShiftNewResponse = await this.$store.dispatch(CREATE_SHIFT_NEW, { newShiftPayload: newShiftPayload })

        if (!newShiftData.IsError && newShiftData && newShiftData.ProjectSeries) {
          const response: EditShiftPlan[] = EditShiftPlan.createListFromResponse(newShiftData.ProjectSeries)

          this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_ID, newShiftData.ProjectSeries[0].ProjektSerieID)
          this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS_LIST, AdditionalGroup.createFromResponse(newShiftData.ProjectSeries[0].Zusatzfelder))

          const availableEmployeeList: EmployeeAvailableForPlanning[] = this.$store.getters[PLANNING_ASSISTANT_GET_EMPLOYEE_LIST_FOR_PLANNING]
          const task: Task[] = this.$store.getters[PLANNING_ASSISTANT_GET_TASK_LIST]

          const employeeDetailsList: any = response[0].details.map((item: ShiftEmployeeDetails) => {
            const foundEmployee: EmployeeAvailableForPlanning | undefined = availableEmployeeList.find((employee: EmployeeAvailableForPlanning) => employee.id === item.employeeId)
            const foundTask: Task | undefined = task.find((task: Task) => task.id === item.taskId)

            return {
              Zeile: item.row,
              MitarbeiterID: item.employeeId ? item.employeeId : null,
              Name: foundEmployee ? foundEmployee.name : undefined,
              Kapazitat: foundEmployee ? foundEmployee.capacity : null,
              Kompetenz: item ? item.competenceName : null,
              Bildung: item ? item.educationName : null,
              ArbeitID: item.taskId ? item.taskId : null,
              Arbeit: foundTask ? foundTask.name : '',
              springer: foundEmployee ? foundEmployee.isFloater : false,
              NotizElement: item.note ? item.note : null,
              startDate: item.dateStart,
              endDate: item.dateEnd,
              ProjectSerie: newShiftData.ProjectSeries[0].ProjektSerieID,
              detailID: item.detailId ? item.detailId : null,
              Planungsgruppe: item.planningGroup ? item.planningGroup : null
            }
          })

          let autoPlannedEmployeeList: Array<AutomaticallyPlannedEmployee | EmployeePlaceholder> = AutomaticallyPlannedEmployee.createListFromResponse(employeeDetailsList, this.companyStructure.planningGroupList)

          this.$store.dispatch(PLANNING_ASSISTANT_SET_AUTOMATIC_PLANNING_IS_PROJECT, false)

          this.$store.dispatch(PLANNING_ASSISTANT_SET_IS_EDITTING_SERIE, true)
          const employeeList: PlannedEmployee[] = PlannedEmployee.createListFromAutoPlannedEmployees(autoPlannedEmployeeList, availableEmployeeList)

          let data: PeriodicityPlannedEmployee[] = []
          employeeList.forEach((item: PlannedEmployee) => {
            let foundItem: PeriodicityPlannedEmployee | undefined

            if (data.length > 0) {
              foundItem = data.find((i: PeriodicityPlannedEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
            }

            if (foundItem) {
              foundItem.employeeList.push(item)
            } else {
              data.push({ date: moment(item.start).format('DD.MM.YYYY'), employeeList: [item] })
            }
          })

          data = _.sortBy(data, [function (o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD') }])

          this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)
        }

        this.isPlaned = true
      } finally {
        this.loading = false
      }
    }
  },

  async mounted (): Promise<void> {
    // noinspection JSIgnoredPromiseFromCall
    this.fetchEmployeePlaceholderList()
  }

})
